'use client';

import { NavArrowDown } from '@byway/icons';
import clsx from 'clsx';
import type { Document } from 'datocms-structured-text-utils';
import { StructuredText } from 'react-datocms';
import { Heading } from '~/components/Heading/src/Heading';
import styles from './SplitAccordionSection.module.css';
import type { SplitAccordionSectionProps } from './SplitAccordionSection.types';

const SplitAccordionSection = ({ header, summary, backgroundColor }: SplitAccordionSectionProps) => {
  const name = header.toLowerCase().replace(/\s+/g, '-');
  return (
    <section
      data-test-id="SplitAccordionSection"
      className={clsx(styles.section, {
        backgroundColor
      })}
    >
      <div className={clsx(styles.grid)}>
        <div className={styles.left}>
          <Heading level="h2" variant="heading-md">
            {header}
          </Heading>
        </div>

        <div className={styles.right}>
          {summary?.map((item) => (
            <details key={item.id} name={name}>
              <summary>
                <span>{item.heading}</span>
                <NavArrowDown decorative className={styles.chevron} />
              </summary>

              <div className={styles.content}>
                <div className={styles.structured}>
                  <StructuredText data={item.body.value as Document} />
                </div>
              </div>
            </details>
          ))}

          <div className={styles.borderline} />
        </div>
      </div>
    </section>
  );
};

export { SplitAccordionSection };
